import React from 'react'
import HeroComponent from '@components/developmentHero/1'
import { RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const Hero = ({
  developmentID,
  multiActionBar,
  align,
  is_short,
  hidden,
  titleInTop,
  global_data,
}: CombinedProps) => {
  return (
    <HeroComponent
      developmentID={developmentID}
      multiActionBar={multiActionBar}
      align={align}
      is_short={is_short}
      titleInTop={titleInTop}
      hidden={hidden}
      global_data={global_data}
    />
  )
}

export default Hero
